import React, { useState } from 'react'
import ReactTable from 'react-table'
import { Link } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'
import _ from 'lodash'
import { Modal, DatePicker } from 'antd'
import moment from 'moment'
import {
  Div, Button, Icon, Input, H3, DynamicButtonLink, Loading,
} from 'konsys-ui'
import axios from 'axios'
import { theme } from '../../../styles/_variables'
import { Wrapper } from '../../../components/good-received-components'
import { GOOD_RECEIVED_LIST } from '../../../constants/graph/query'
import { ListContainer, Select } from '../../../components/common'
import { PAYMENT_TYPE } from '../constants'
import './style-css.css'
import { getAccessToken, getURL } from '../../../utils/local-data-service'
import PERMISSION from '../../../constants/permissions'
import config from './config'

const { color } = theme

const Index = () => {
  const [isLoading, setIsLoading] = useState()
  const [monthReportModal, setMonthReportModal] = useState(false)
  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>รายการใบรับสินค้า</H3>
        <Div display='flex' flexDirection='row' justifyContent='space-between'>
          <DynamicButtonLink link='/good-received/add' condition={_.includes(window.perms, PERMISSION.CREATE_GOOD_RECEIVED)} props={{ text: 'สร้างใบรับสินค้า' }} />
        </Div>
      </Div>
      <List />
    </Div>
  )
}

export const List = () => {
  const [current, setCurrent] = useState(0)
  const [variable, setVariable] = useState({})
  const {
    data, loading, error, fetchMore, refetch,
  } = useQuery(GOOD_RECEIVED_LIST, {
    variables: {
      ...variable,
      limit: 5,
      offset: 5 * current,
      orderField: 'updatedAt',
      orderBy: 'DESC',
    },
  })
  return (
    <Wrapper overflow padding='0 0 40px 0'>
      {loading && _.isEmpty(data) && <Loading center='true' />}
      {(!loading || !_.isEmpty(data))
        && <Div>
          <ReactTable
            className='table'
            data={data.GoodReceiveList.lists} // *
            resizable={false}
            columns={config.columns} // *
            minRows={5}
            manual
            // defaultPageSize={10}
            showPageSizeOptions={false}
            getTdProps={() => ({ disabled: true })} // *
            getTrProps={(state, rowInfo) => { // *
              if (rowInfo) {
                return {
                  style: {
                    padding: '8px 0',
                    backgroundColor: '#ffffff',
                    borderLeft: `3px solid ${color.primaryColor}`,
                  },
                }
              } return {}
            }}
            previousText='ก่อนหน้า'
            nextText='ถัดไป'
            pageText='หน้า'
            ofText='จาก'
            page={current}
            pages={Math.ceil(data.GoodReceiveList.totalFilter / 5)}
            onPageChange={page => setCurrent(page)}
            onFilteredChange={async (newFiltered) => {
              const newOjb = {
                refId: '',
                PurchaseOrder: { number: '' },
                Supplier: { name: '' },
                supplierRefId: '',
                firstname: '',
                lastname: '',
              }
              await newFiltered.forEach((v) => {
                if (v.id === 'Supplier.name') {
                  Object.assign(newOjb, { Supplier: { name: v.value } })
                } else if (v.id === 'PurchaseOrder.number') {
                  Object.assign(newOjb, { PurchaseOrder: { number: v.value } })
                } else if (v.id === 'User.firstname') {
                  Object.assign(newOjb, { firstname: v.value })
                } else if (v.id === 'User.lastname') {
                  Object.assign(newOjb, { lastname: v.value })
                } else {
                  Object.assign(newOjb, { [v.id]: v.value })
                }
              })
              setCurrent(0)
              refetch(newOjb)
              setVariable(newOjb)
            }}
            onSortedChange={async (newSorted) => {
              setCurrent(0)
              refetch({
                orderBy: newSorted[0].desc ? 'DESC' : 'ASC',
                orderField: newSorted[0].id,
              })
            }}
          />
          {
            loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
          }
        </Div>
      }
    </Wrapper>
  )
}

export default Index
